const { fetchJSON } = window.BAO.Utils

class StoreSwitcher extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.optionsHtml = ''
  }

  connectedCallback () {
    super.connectedCallback()

    /* Force redirect - Start */
    if (window.location.href.indexOf('#geo') > -1) {
      return this.forceRedirect()
    }
    /* Force redirect - End */

    /* ?country= in URL check - Start */
    // eslint-disable-next-line compat/compat
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    })
    this.countryParam = params.country

    if (this.countryParam !== null) {
      this.setStorageFromURL(this.countryParam)
    }
    /* ?country= in URL check - End */

    if (this.countryParam !== null) {
      const countryCode = this.countryParam

      this.setupCountrySwitcher(countryCode)
      // this.updateShippingLabel(countryCode)
    } else if (!this.noLocationStored) {
      const countryCode = window.localStorage.getItem(this.userLocationName)

      this.setupCountrySwitcher(countryCode)
      // this.updateShippingLabel(countryCode)
    } else {
      fetchJSON('/browsing_context_suggestions.json', {
        method: 'GET',
      }).then((res) => {
        const countryCode = res.detected_values.country.handle

        this.setupCountrySwitcher(countryCode)
        // this.updateShippingLabel(countryCode)
      })
    }

    this.setupListeners()
  }

  forceRedirect () {
    fetchJSON('/browsing_context_suggestions.json', {
      method: 'GET',
    }).then((res) => {
      const userCountry = res.detected_values.country.handle

      let windowPathname = window.location.pathname

      const subdomainFolder = windowPathname.split('/').filter((item) => {
        return item.indexOf('en-') > -1
      })

      if (subdomainFolder) {
        windowPathname = windowPathname
          .replace(subdomainFolder, '')
          .replace('//', '/')
      }

      window.location.href = `${
        this.sites[this.countries[userCountry].site].url
      }${windowPathname}?country=${userCountry}`
    })
  }

  setupListeners () {
    super.setupListeners()

    this.onOptionClick = this.onOptionClick.bind(this)
    this.onConfirmClick = this.onConfirmClick.bind(this)

    if (this.els?.options?.exists) {
      this.els.options.elements.forEach((optionEl) => {
        this.listeners.add(optionEl, 'change', this.onOptionClick)
      })
    }

    if (this.els?.confirm?.exists) {
      this.els.confirm.elements.forEach((confirmEl) => {
        this.listeners.add(confirmEl, 'click', this.onConfirmClick)
      })
    }

    /* Check for existing BAO-localization in localStorage before setting up the observer */
    if (!window.localStorage.getItem(this.userLocationName)) {
      if (
        this.els?.autoRedirect?.exists &&
        this.els.confirm?.exists &&
        !this.autoRedirectFired
      ) {
        const observer = new MutationObserver((mutationsList) => {
          for (const mutation of mutationsList) {
            if (
              mutation.type === 'attributes' &&
              mutation.attributeName === 'data-url' &&
              !this.autoRedirectFired
            ) {
              const redirectUrl = this.els.confirm.element.dataset.url
              if (redirectUrl) {
                this.autoRedirectFired = true
                observer.disconnect()
                window.location.href = redirectUrl
              }
            }
          }
        })

        observer.observe(this.els.confirm.element, {
          attributes: true,
          attributeFilter: ['data-url'],
        })
      }
    }
  }

  setStorageFromURL (countryCode) {
    if (this.countries[countryCode].site === this.dataset.store) {
      window.localStorage.setItem(this.userLocationName, countryCode)
    }
  }

  onOptionClick (e) {
    const selectedOptionValue = e.currentTarget.value
    const selectedOptionCode =
      e.currentTarget.options[e.currentTarget.selectedIndex].dataset.code

    this.els.confirm.elements.forEach((confirmEl) => {
      confirmEl.dataset.url = this.sites[selectedOptionValue].url
      confirmEl.dataset.code = selectedOptionCode
    })
  }

  onConfirmClick (event) {
    event.preventDefault()

    let windowPathname = window.location.pathname

    const subdomainFolder = windowPathname.split('/').filter((item) => {
      return item.indexOf('en-') > -1
    })

    if (subdomainFolder) {
      windowPathname = windowPathname
        .replace(subdomainFolder, '')
        .replace('//', '/')
    }

    if (
      this.countries[event.currentTarget.dataset.code].site ===
      this.dataset.store
    ) {
      window.localStorage.setItem(
        this.userLocationName,
        event.currentTarget.dataset.code,
      )

      this.els['localisation-select'].element.value =
        event.currentTarget.dataset.code
      this.els['localisation-select'].element.dispatchEvent(
        new Event('change'),
      )
    } else if (event.currentTarget.hasAttribute('data-url')) {
      window.location.href = `${event.currentTarget.dataset.url}${this.dataset.pageUrl}?country=${event.currentTarget.dataset.code}`
    }
  }

  updateShippingLabel (countryCode) {
    if (this.noLocationStored) return

    const upperCountryCode = countryCode.toUpperCase()

    if (this.countries[upperCountryCode] !== undefined) {
      const name = this.countries[upperCountryCode].name

      if (this.externalEls?.country?.exists) {
        this.externalEls.country.elements.forEach((countryExternalEl) => {
          countryExternalEl.innerHTML = `${name}`
        })
      }

      /* Added due to trigger in mobile menu being rendered after page load */
      window.setTimeout(() => {
        document
          .querySelectorAll('[data-store-switcher-external-el="country"]')
          .forEach((el) => {
            el.innerHTML = `${name}`
          })
      }, 1000)
    }

    if (this.externalEls?.trigger?.exists) {
      this.externalEls.trigger.elements.forEach((triggerExternalEl) => {
        triggerExternalEl.style.opacity = 1
      })
    }
  }

  setupCountrySwitcher (countryCode) {
    this.createOptions(countryCode)
    this.setDefaultConfirmButtonURL()

    if (this.countries[countryCode].site === this.dataset.store) {
      window.localStorage.setItem(this.userLocationName, countryCode)
    }

    if (!this.noLocationStored) return

    if (this.countryParam !== null) return

    this.setAttribute('aria-hidden', 'false')
    document.body.classList.add('util-SiteOverflowed')
  }

  createOptions (countryCode) {
    Object.entries(this.countries).forEach(([key, value]) => {
      const { name, site, currency } = value
      const isCurrentSite = key.toLowerCase() === countryCode.toLowerCase()
      this.optionsHtml += this.createModalElement(
        key,
        site,
        isCurrentSite,
        name,
        currency,
      )

      this.els.options.element.innerHTML = this.optionsHtml

      this.externalEls.drawer.element.innerHTML += this.createDrawerElement(
        key,
        site,
        isCurrentSite,
        name,
        currency,
      )
    })
  }

  createModalElement (code, site, isCurrentSite, country, currency) {
    return `<option
      data-code="${code}"
      value="${site}"
      ${isCurrentSite ? 'selected' : ''}
    >
      ${country} (${currency})
    </option>`
  }

  createDrawerElement (code, site, isCurrentSite, country, currency) {
    return `<li class="str-Drawer_Item">
      <a
        class="str-Drawer_Link fz-13_160"
        href="${this.sites[site].url}${this.dataset.pageUrl}?country=${code}"
        aria-current="${isCurrentSite ? 'true' : 'false'}"
      >
        ${country} (${currency})

        <span class="str-Drawer_Tick">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 9">
            <path fill="currentColor" fill-rule="evenodd" d="M11.304 1.146a.5.5 0 0 1 0 .708l-6.3 6.3a.5.5 0 0 1-.708 0l-3.15-3.15a.5.5 0 1 1 .708-.708L4.65 7.093l5.946-5.947a.5.5 0 0 1 .708 0Z" clip-rule="evenodd"/>
          </svg>
        </span>

        <span class="str-Drawer_Arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
            <path d="M0.480469 6.00013H11.4358M11.4358 6.00013L5.95814 0.522461M11.4358 6.00013L5.95814 11.4778" stroke="currentColor" />
          </svg>
        </span>
      </a>
    </li>`
  }

  setDefaultConfirmButtonURL () {
    const selectedOptionValue = this.els.options.element.value
    const selectedOptionCode =
      this.els.options.element.options[this.els.options.element.selectedIndex]
        .dataset.code

    this.els.confirm.elements.forEach((confirmEl) => {
      confirmEl.dataset.url = this.sites[selectedOptionValue].url
      confirmEl.dataset.code = selectedOptionCode
    })
  }

  get noLocationStored () {
    return (
      window.localStorage.getItem(this.userLocationName) == null ||
      (window.localStorage.getItem(this.userLocationName) === undefined &&
        !window.Shopify.designMode)
    )
  }

  get userLocationName () {
    return 'BAO-localization'
  }

  get sites () {
    return {
      UK: {
        url: 'https://www.mauvais.co.uk',
      },
      US: {
        url: 'https://us.mauvais.co.uk',
      },
      ROW: {
        url: 'https://row.mauvais.co.uk',
      },
    }
  }

  get countries () {
    return window.theme.countries
  }
}

if (!customElements.get('store-switcher')) {
  customElements.define('store-switcher', StoreSwitcher)
}
